import React from "react";
import { useCompanyTimezone, useDisplayTimezone } from "hooks/useTimezone";
import {
  CurrentDateDisplayProps
} from "./CurentDateDisplayTypes";
import { getTextColor } from "../charts/utils";
import "./CurrentDateDisplay.scss";
import getCurrentDate from "./CurrentDateDisplayUtils";

export default function CurrentDateDisplay(props: CurrentDateDisplayProps) {
  const displayTz = useDisplayTimezone();
  const companyTz = useCompanyTimezone();

  return (
    <div
      className="current-date-display-component"
      style={{ color: getTextColor(props.theme) }}
    >
      {getCurrentDate(props.year, props.month, props.day, displayTz, companyTz)}
    </div>
  );
}
